import { useEffect, useState } from 'react';
import { useAppSelector } from 'store/hooks';
import { selectSDKBaseDomain } from 'features/sdk/sdkStateSlice';
import { requestInvitationLinkService } from 'features/users/services';
import { replaceInviteLinkDomain } from 'utils/url/replaceInviteLinkDomain';

interface UseInviteLinkResult {
  inviteLink: string;
  error: boolean;
  isLoading: boolean;
}

export const useInviteLink = (selectedRole: string): UseInviteLinkResult => {
  const sdkBaseDomain = useAppSelector(selectSDKBaseDomain);

  const [inviteLink, setInviteLink] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchLink = async () => {
      setInviteLink('');
      setError(false);

      try {
        const link = await requestInvitationLinkService(selectedRole);
        const processedLink = replaceInviteLinkDomain(link, sdkBaseDomain);
        setInviteLink(processedLink);
      } catch {
        setError(true);
      }
    };

    fetchLink();
  }, [selectedRole, sdkBaseDomain]);

  return {
    inviteLink,
    error,
    isLoading: !inviteLink && !error,
  };
};
